import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>404</h1>
        <p style={styles.message}>The page you are looking for cannot be found.</p>
        <button style={styles.button} onClick={() => navigate('/')}>Go Home</button>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f8fafc',
    padding: '24px',
  },
  card: {
    maxWidth: '420px',
    width: '100%',
    background: '#ffffff',
    borderRadius: '24px',
    padding: '32px',
    textAlign: 'center',
    boxShadow: '0 24px 64px rgba(15, 23, 42, 0.08)',
  },
  title: {
    margin: 0,
    fontSize: '54px',
    fontWeight: 800,
    color: '#0f172a',
  },
  message: {
    margin: '16px 0 24px',
    color: '#475569',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  button: {
    background: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '9999px',
    padding: '12px 24px',
    cursor: 'pointer',
    fontWeight: 700,
  },
};

export default NotFound;
